"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilesCarousel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var simple_react_lightbox_1 = __importStar(require("simple-react-lightbox"));
var react_multi_carousel_1 = __importDefault(require("react-multi-carousel"));
require("react-multi-carousel/lib/styles.css");
var core_1 = require("@material-ui/core");
var styles_1 = __importDefault(require("./styles"));
var atoms_1 = require("../../atoms");
var videoFormats = ['mp4', 'mov', 'wmv', 'avi', 'mkv', 'flv', 'qt'];
/**
 * @deprecated
 */
var FilesCarousel = function (_a) {
    var files = _a.files, docs = _a.docs;
    var classes = (0, styles_1.default)();
    var mappedThumbnails = files.map(function (item) {
        var isVideo = videoFormats.includes(item.type);
        var crossOrigin = isVideo ? undefined : 'anonymous';
        var imgFull = isVideo ? item.thumbnail : item.src;
        var imgThumbnail = item.thumbnail;
        return ((0, jsx_runtime_1.jsx)("a", __assign({ href: imgFull }, { children: (0, jsx_runtime_1.jsx)("img", { style: {
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                }, id: item.id, alt: item.id, src: imgThumbnail, crossOrigin: crossOrigin }) }), item.id));
    });
    var responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 10,
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 9,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 8,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 7,
        },
    };
    var openDoc = function (item) {
        var newWindow = window.open(item.link, '_blank', 'noopener,noreferrer');
        if (newWindow)
            newWindow.opener = null;
    };
    var downloadFile = function (object) {
        var file = files[object === null || object === void 0 ? void 0 : object.id];
        if (videoFormats.includes(file.type)) {
            var a = document.createElement('a');
            a.href = file.src;
            a.target = '_blank';
            a.download = "video-".concat(file.id, ".mp4");
            a.click();
        }
    };
    var mappedDocs = docs.map(function (item) { return ((0, jsx_runtime_1.jsx)(core_1.Grid, __assign({ item: true, xs: 2 }, { children: (0, jsx_runtime_1.jsx)(core_1.Box, __assign({ marginTop: "10px", onClick: function () {
                openDoc(item);
            } }, { children: (0, jsx_runtime_1.jsx)(atoms_1.IconChip, { fileType: item.type, chipText: item.type, fileName: item.name, hideClose: true }) })) }), item.id)); });
    var callbacks = {
        onSlideChange: function (object) { var _a; return downloadFile((_a = object === null || object === void 0 ? void 0 : object.slides) === null || _a === void 0 ? void 0 : _a.current); },
        onLightboxOpened: function (object) { return downloadFile(object === null || object === void 0 ? void 0 : object.currentSlide); },
    };
    return ((0, jsx_runtime_1.jsxs)(simple_react_lightbox_1.default, { children: [(0, jsx_runtime_1.jsx)(simple_react_lightbox_1.SRLWrapper, __assign({ callbacks: callbacks }, { children: (0, jsx_runtime_1.jsx)(react_multi_carousel_1.default, __assign({ className: classes.root, draggable: true, partialVisbile: true, itemClass: "image-item", responsive: responsive }, { children: mappedThumbnails })) })), (0, jsx_runtime_1.jsx)(core_1.Grid, __assign({ container: true, spacing: 2 }, { children: mappedDocs }))] }));
};
exports.FilesCarousel = FilesCarousel;
